import { render } from "./PurchaseCheckoutPayment.vue?vue&type=template&id=588370fa"
import script from "./PurchaseCheckoutPayment.vue?vue&type=script&lang=js"
export * from "./PurchaseCheckoutPayment.vue?vue&type=script&lang=js"

import "./PurchaseCheckoutPayment.vue?vue&type=style&index=0&id=588370fa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__